module.exports = __webpack_public_path__ + "static/media/032.6d45bb3f.jpg";